import { Component, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Subscription, Observable, of } from 'rxjs';
import { take, toArray } from 'rxjs/operators';
import { Logistiques } from '../../logistiques';
import { LogistiquesService } from '../../logistiques.service';

@Component({
  selector: 'app-produits-abonnes',
  templateUrl: './produits-abonnes.component.html',
  styleUrls: ['./produits-abonnes.component.css']
})
export class ProduitsAbonnesComponent implements OnChanges, OnDestroy {
  @Input() id: string;
  subscription = new Subscription();
  p: Logistiques;
  abonnes = 0;
  loading = true;
  errorLoading = '';

  constructor(
    private service: LogistiquesService
  ) { }

  ngOnChanges(): void {
    this.getServiceAbonnes(this.id);
  }

  getServiceAbonnes(id: string): void {
    this.subscription.add(
      this.service.views('services_abonnes', id)
        .subscribe(arg => {
          this.abonnes = arg.length;
          this.loading = false;
        },
          erg => {
            this.errorLoading = 'Erreur de chargement de données';
            this.loading = false;
          })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


}
